import { NgModule } from '@angular/core';
import {CommonModule, CurrencyPipe, DatePipe} from '@angular/common';
import {SharedService} from "./services/shared.service";
import {MatTabsModule} from "@angular/material/tabs";
import {MonetaryFormatterPipe} from "./pipes/monetary-formatter.pipe";
import {BaseModal} from "./components/modal/base-modal";
import {DebugPanelComponent} from "./components/debug-panel/debug-panel.component";
import {ShowErrorsComponent} from "./components/show-errors/show-errors.component";
import {CustomValidators} from "./services/custom-validators";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {CountdownModule} from "ngx-countdown";
import {ToastrModule} from "ngx-toastr";
import {ConfirmationPopupComponent} from "./components/confirmation-popup/confirmation-popup.component";
import { NinFormatterPipe } from './pipes/nin-formatter.pipe';
import { InvoiceFilterPipe } from './pipes/invoice-filter.pipe';
import {AutoAddProtocolPipe} from "./pipes/auto-add-protocol.pipe";
import { MembershipInvoiceFilterPipe } from './pipes/membership-invoice-filter.pipe';
import { MembershipInvoiceYearExtractorPipe } from './pipes/membership-invoice-year-extractor.pipe';
import {NgxSpinnerModule} from "ngx-spinner";
import {UserManagerService} from "./services/user-manager.service";
import { MemberFilterPipe } from './pipes/member-filter.pipe';
import { BoligFilterPipe } from './pipes/bolig-filter.pipe';
import { CustomDatePipe } from './pipes/custom-date.pipe';
import { BankIdMaskDirective } from './directives/bank-id-mask.directive';
import { NgMultiSelectCustomModule } from './components/multiselect';
import { AddressFormatterPipe } from './pipes/address-formatter.pipe';



@NgModule({
  declarations: [
    MonetaryFormatterPipe,
    BaseModal,
    DebugPanelComponent,
    ShowErrorsComponent,
    ConfirmationPopupComponent,
    NinFormatterPipe,
    InvoiceFilterPipe,
    AutoAddProtocolPipe,
    MembershipInvoiceFilterPipe,
    MembershipInvoiceYearExtractorPipe,
    MemberFilterPipe,
    BoligFilterPipe,
    CustomDatePipe,
    BankIdMaskDirective,
    AddressFormatterPipe
  ],
  imports: [
    CommonModule,
    MatTabsModule,
    TooltipModule.forRoot(),
    NgxSpinnerModule,
    CountdownModule,

    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    NgMultiSelectCustomModule.forRoot()

  ],
    exports: [
        MatTabsModule,
        MonetaryFormatterPipe,
        DebugPanelComponent,
        ShowErrorsComponent,
        TooltipModule,
        CountdownModule,
        NgxSpinnerModule,
        ToastrModule,
        NinFormatterPipe,
        InvoiceFilterPipe,
        AutoAddProtocolPipe,
        MembershipInvoiceFilterPipe,
        MembershipInvoiceYearExtractorPipe,
        MemberFilterPipe,
        BoligFilterPipe,
        CustomDatePipe,
        BankIdMaskDirective,
        NgMultiSelectCustomModule,
        AddressFormatterPipe
    ],
  providers: [
    SharedService,
    MonetaryFormatterPipe,
    CurrencyPipe,
    CustomValidators,
    UserManagerService,
    DatePipe,
    CustomDatePipe
  ]
})
export class SharedModule { }
